export default {
  SET_VIDEO_LIBRARY (state, report) {
    state.videoLibrary = report
  }
}
